import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import translate from '../../i18n/translate';

class DemoItem extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { link, image, description } = this.props.DemoItemContent;
        return (
            <div className="linkDemo-item">
                <img className="demo-image" src={image}></img>
                <h4 onClick={()=>{this.props.test(link)}}>
                    <Link to={link}>{description}</Link>
                </h4>
            </div>
        );
    }
}

export default DemoItem;


// WEBPACK FOOTER //
// ./client/components/DemoItem.js